<template>
  <div class="aws-container">
      <div class="aws-inner-container">
            <div class="aws-input-container" style="margin-bottom: 0">
                <input id="awsAddress" class="aws-search-address" type="text" :placeholder="placeHolder" v-model="searchAddress.userInput">
                <!-- <div class="custom-button-container">
                    <button @click="customAddressToggle()" v-if="toggleCustomAddressButton">Custom Address</button>
                </div> -->
            </div>

            <div class="auto-complete-result-container">
                <div class="autocomplete-result" id="autocomplete-result" v-if="searchAddress.userInput.length > 3">
                    <p @click="SelectAddress(index)" v-for="(autoCompleteResult, index) in autoCompleteData" :key="autoCompleteResult"><i class="fa fa-map-pin"></i><span style="font-weight: bold;">{{autoCompleteResult.serviceAddress.address.companyName}}</span> {{autoCompleteResult.serviceAddress.address.address1}}, {{autoCompleteResult.serviceAddress.address.city}}, {{autoCompleteResult.serviceAddress.address.state}} {{autoCompleteResult.serviceAddress.address.zipCode}}</p>
                    <p v-show="searchAddress.userInput.length > 3">Searching contracted locations</p>
                    <!-- v-show="autoCompleteData.length <= 2" -->
                </div>
            </div>
      </div>
  </div>
</template>

<script>
/**
 * AWS Location Services Component
 * Creates dropdown with address suggestion
 * */
// import Location from "aws-sdk/clients/location";
import {API} from 'aws-amplify';

export default {
    props: ['placeHolder', 'userData'],
    data(){
        return{
            searchAddress:{
                userInput: ""
            },
            autoCompleteData: {},
            addressDataInput: {},
            toggleCustomAddressButton: false,
            locationAccountData: []
        }
    },
    // computed: {
    //     filteredAddresses() {
    //         const lowerSearch = this.searchAddress.userInput.toLowerCase()

    //         return this.locationAccountData.filter(item => {
    //             const addressObj = item.serviceAddress.address
    //             return Object.values(addressObj).some(val => {
    //             if (!val) return false
    //             this.autoCompleteData = val.toString().toLowerCase().includes(lowerSearch)
    //             //return val.toString().toLowerCase().includes(lowerSearch)
    //             })
    //         })
    //     }
    // },
    methods:{
        filteredAddresses() {
            const lowerSearch = this.searchAddress.userInput.toLowerCase()
            console.log(lowerSearch)
            console.log("Account Location: ", this.locationAccountData)

            this.autoCompleteData = this.locationAccountData.filter(item => {
                const addressObj = item.serviceAddress.address
                    return Object.values(addressObj).some(val => {
                        return val && val.toString().toLowerCase().includes(lowerSearch)
                })
            })
            console.log("AutoComplete: ", this.autoCompleteData)
        },
        async getAccountLocations() {
            console.log(this.userData);

            const PAGE_LIMIT = 100; // AppSync max per request
            const MAX_ITEMS = 300;

            let allItems = [];
            let nextToken = null;

            try {
                do {
                    const graphqlQuery = `
                        query locationByAccountNo($accountNo: String!, $nextToken: String) {
                            locationByAccountNo(
                                accountNo: $accountNo,
                                filter: { isContractedDelivery: { eq: true } },
                                limit: ${PAGE_LIMIT},
                                nextToken: $nextToken
                            ) {
                                items {
                                    id
                                    serviceAddress {
                                        address {
                                            companyName
                                            attention
                                            address1
                                            address2
                                            city
                                            state
                                            zipCode
                                            phone
                                            phoneExt
                                            relevance
                                            latitude
                                            longitude
                                            routeCode
                                        }
                                    }
                                }
                                nextToken
                            }
                        }
                    `;

                    const response = await API.graphql({
                        query: graphqlQuery,
                        variables: {
                            accountNo: this.userData.accountNo,
                            nextToken
                        },
                        authMode: "AMAZON_COGNITO_USER_POOLS"
                    });

                    const result = response.data.locationByAccountNo;

                    allItems.push(...(result.items || []));
                    nextToken = result.nextToken;

                } while (nextToken && allItems.length < MAX_ITEMS);

                this.locationAccountData = allItems;
                
                console.log("ACCOUNT LOCATION DATA:", this.locationAccountData.length);

            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting locations";
            }
        },
        // async getAccountLocations(){
        //     console.log(this.userData)
        //     let graphqlQuery = `query locationByAccountNo{
        //         locationByAccountNo(accountNo: "${this.userData.accountNo}", filter: {isContractedDelivery:{eq: true}}){
        //             items{
        //             id
        //             serviceAddress{
        //                 address{
        //                 companyName
        //                 attention
        //                 address1
        //                 address2
        //                 city
        //                 state
        //                 zipCode
        //                 phone
        //                 phoneExt
        //                 relevance
        //                 latitude
        //                 longitude
        //                 routeCode
        //                 }
        //             }
        //             }
        //         }
        //     }
        //     `
            
        //     try{
        //         let locationsByAccount = await API.graphql({
        //         query:  graphqlQuery,
        //         authMode: "AMAZON_COGNITO_USER_POOLS",
        //         })
                
        //         this.locationAccountData = locationsByAccount.data.locationByAccountNo.items;
        //         console.log("ACCOUNT LOCATION DATA: ", this.locationAccountData.length)
        //     }catch(e){
        //         console.log(e)
        //         if(e){
        //             this.toggleAlertBox = true;
        //             this.alertMessage = "Error getting locations"
        //         }
        //     }
        // },
        /**
         * Calls searchPlaceIndexForText to get address data
         * If data is returned set autoCompleteData
         */
        // async getLocationData(){
        //     const credentials = await Auth.currentCredentials();

        //     const locationClient = new Location({
        //         credentials,
        //         region: 'us-east-1'
        //     });

        //     const params = {
        //         IndexName: "lrex-place",
        //         Text: this.searchAddress.userInput,
        //         //Text: "233 Washington St, Newark, NJ, 07102, USA",
        //         FilterCountries: ["USA"],
        //         BiasPosition: [-74.1724, 40.7357],
        //         MaxResults: 5
        //     };

        //     if(this.searchAddress.userInput.length > 1){

        //         locationClient.searchPlaceIndexForText(params,(err,data)=>{
        //             if(err){
        //                 alert("Error with Location Services.")
        //             }
        //             if(data){
        //                 //Only suggest addresses with Street and AddressNumber Values
        //                 if(data.Results[0]){
        //                     if(data.Results[0].Place.AddressNumber || data.Results[0].Place.Street){
        //                         this.autoCompleteData = data.Results;
        //                         // console.log(this.autoCompleteData)
        //                     }
        //                 }
        //             }
        //         })
        //     }
        // },
        /**
         * Set addressDataInput to returned data from autoCompleteData
         * autoCompleteData[index].Place returns address data
         * autoCompleteData[index].Relevance return relevance compared to user input
         */
        SelectAddress(index) {
            const selected = this.autoCompleteData[index]?.serviceAddress?.address ?? {};
            this.addressDataInput = {
                address1: selected.address1 ? selected.address1 : "",
                city: selected.city ? selected.city : "",
                zipCode: selected.zipCode ? selected.zipCode.substring(0, 5) : "",
                latitude: selected.latitude ? selected.latitude : "",
                longitude: selected.longitude ? selected.longitude : "",
                relevance: selected.relevance ? selected.relevance : "",
                state: selected.state ? selected.state : "",
                companyName: selected.companyName ? selected.companyName : "",
                phone: selected.phone ? selected.phone : ""
            };

            // Emit final result
            this.$emit("GetSelectedAddressData", this.addressDataInput);

            // Clear search UI
            this.searchAddress.userInput = "";
        },
        // SelectAddress(index){
        //     let selectedAddressData = this.autoCompleteData[index].serviceAddress.address;
        //     //User selected this address set relevance to 1

        //     if(selectedAddressData.address1){
        //         this.addressDataInput.address1 = selectedAddressData.address1;
        //     }else{
        //         this.$emit('GetSelectedAddressData', false);
        //     }

        //     if(selectedAddressData.city){
        //         this.addressDataInput.city = selectedAddressData.city;
        //     }else{
        //         this.$emit('GetSelectedAddressData', false);
        //     }

        //     if(selectedAddressData.zipCode){
        //         this.addressDataInput.zipCode = selectedAddressData.zipCode.substring(0, 5);
        //     }else{
        //         this.$emit('GetSelectedAddressData', false);
        //     }

        //     if(selectedAddressData.latitude){
        //         this.addressDataInput.latitude = selectedAddressData.latitude;
        //         this.addressDataInput.longitude = selectedAddressData.longitude;
        //     }else{
        //         this.$emit('GetSelectedAddressData', false);
        //     }

        //     if(selectedAddressData.relevance){
        //         this.addressDataInput.relevance = selectedAddressData.relevance;
        //     }else{
        //         this.$emit('GetSelectedAddressData', false);
        //     }

        //     if(selectedAddressData.state){
        //         this.addressDataInput.state = selectedAddressData.state;
        //     }else{
        //         this.$emit('GetSelectedAddressData', false);
        //     }
            
        //     this.$emit('GetSelectedAddressData', this.addressDataInput);
        //     this.searchAddress.userInput = "";
        // },
        // customAddressToggle(){
        //     this.$emit('customAddressToggle', true);
        // }
    },
    /**
     * Call AWS location to get address suggestion when user types in input
     */
    watch:{
      'searchAddress.userInput': function(){
          if(this.searchAddress.userInput.length > 3){
            this.filteredAddresses()
            // this.getLocationData();
            // this.toggleCustomAddressButton = true;
          }
        },
        'userData': function(){
            this.getAccountLocations()
        }
    },
    mounted(){
        this.getAccountLocations()
        //Close suggestion box when user clicks outside of it
            var vueInstance = this;
            document.addEventListener('click', function clickOutsideAutoComplete(event){
                const autocompleteBox = document.getElementById('awsAddress');
                if(vueInstance.searchAddress.userInput.length > 0){
                    if(!autocompleteBox.contains(event.target)){
                        vueInstance.searchAddress.userInput = "";
                    }
                }
            })
        }
}
</script>

<style scoped>

    .aws-input-container{
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .custom-button-container{
        margin: 1px;
    }

    .custom-button-container button{
        padding-top: 2.5px;
        padding-bottom: 2.5px;
        padding-right: 5px;
        padding-left: 5px;
        border: none;
        border-radius: 50px;
        cursor: pointer;
        font-size: 12px;
        color: #fff;
        background-color: #32ccfe;
    }

    .aws-search-address{
        padding: 10px 0px 10px 10px;
        font-size: 15px;
        border: 1px solid rgba(0, 0, 0, 0.336);
        border-radius: 5px;
        outline: none;
        width: 100%;
        margin-bottom: 0;
    }

    /* AWS Location Service */
    .fa-map-pin{
        color: #999;
        margin-right: 5px;
        font-size: 1em;
    }

    .autocomplete-result{
        background-color: #fff;
        border-radius: 5px;
        text-align: left;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.062);
        margin-bottom: 10px;
        position: absolute;
        z-index: 10;
    }

    @keyframes animate-result {
        from{
            margin-top: -5px;
        }
        to{
            margin-top: 0;
        }
    }

    .autocomplete-result p{
        cursor: pointer;
        transition-duration: .5s;
        margin: 0;
        padding: 10px;
        font-size: 12px;
        animation: animate-result .5s ease;
        border-bottom: 1px solid rgb(235, 235, 235);
    }

    .autocomplete-result p:hover{
        background-color: rgb(235, 235, 235);
        transition-duration: .5s;
    }
</style>